import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		cart: []
	},
	plugins: [createPersistedState()],
	mutations: {
	    cart (state, value) {
	    	state.cart = value;
	    }
	}
});


// WEBPACK FOOTER //
// ./resources/assets/js/store.js